import React from 'react'

const GalleryWrap = () => {
    const galleryobj = [
        {
            id:1,
            datasrc:"assets/img/2021-gallery/about-1st.webp",
            img:"assets/img2023/about-2st.webp"
        },
        {
            id:2,
            datasrc:"assets/img/2021-gallery/b.webp",
            img:"assets/img/2021-gallery/b.webp"
        },
        {
            id:3,
            datasrc:"assets/img/2021-gallery/trsm.webp",
            img:"assets/img/2021-gallery/trsm.webp"
        },
        {
            id:4,
            datasrc:"assets/img/2021-gallery/f.webp",
            img:"assets/img/2021-gallery/f.webp"
        },
        {
            id:5,
            datasrc:"assets/img/2021-gallery/c.webp",
            img:"assets/img/2021-gallery/c.webp"
        },
        {
            id:6,
            datasrc:"assets/img/2021-gallery/g.webp",
            img:"assets/img/2021-gallery/g.webp"
        },
        {
            id:7,
            datasrc:"assets/img/2021-gallery/7.webp",
            img:"assets/img/2021-gallery/7.webp"
        },
        {
            id:8,
            datasrc:"assets/img/2021-gallery/8.webp",
            img:"assets/img/2021-gallery/8.webp"
        },
        // {
        //     id:9,
        //     datasrc:"assets/img/2021-gallery/about-g1.webp",
        //     img:"assets/img/2021-gallery/about-g1.webp"
        // },
        // {
        //     id:10,
        //     datasrc:"assets/img/2021-gallery/10.webp",
        //     img:"assets/img/2021-gallery/10.webp"
        // },
    ];
    return (
        <>
                <section className="gallery_wrap">
                    <div className="gallery-container" id="animated-thumbnails-gallery">
                        {galleryobj.map((galCar) => {
                           return <a className="gallery-item small" data-src={galCar.datasrc}>
                                <img className="img-responsive" src={galCar.img} loading="lazy" />
                            </a>
                        })}
                    </div>
                </section>
        </>
    )
}

export default GalleryWrap